<div class="container">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="107"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <div class="d-flex flex-wrap column-gap-4">
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="sites-by-migration-progress-chart"
          [isRefreshing]="isSitesByProgressRefreshing()"
          [isError]="isDnReportWidgetError"
          [data]="sitesByProgressData"
          [label]="'tkey;migrations.site_progress.label'"
          [labelTooltip]="'tkey;migrations.site_progress.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="sitesByProgressCustomColors"
          [isDisabled]="!isSiteConfigurationComplete"
          [disabledText]="siteConfigurationDisabledText"
          [disabledActionLabel]="'tkey;migrations.site_configuration.button.label'"
          [footerNote]="sitesByProgressFooterNote"
          [segmentTooltipKeyword]="'tkey;migrations.site_progress.sites.label'"
          [totalSubtext]="'tkey;migrations.site_progress.total_sites.label'"
          [legendCountLabelSingular]="'tkey;migrations.site_progress.sites.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.site_progress.sites.label.plural'"
          (dataClick)="onSitesByProgressClick($event)"
          (disabledActionClick)="onConfigureSitesClick()"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="migration-status-chart"
          [isRefreshing]="isDnReportDataRefreshing()"
          [isError]="isDnReportWidgetError"
          [data]="migrationStatusData"
          [label]="'tkey;migrations.number_report.dashboard.migration_status.label'"
          [labelTooltip]="'tkey;migrations.cisco.directory_numbers_report.dashboard.migration_status.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="migrationStatusCustomColors"
          [segmentTooltipKeyword]="'tkey;migrations.number_report.dashboard.numbers.label'"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onDnReportFilter($event, 'migrationStatus')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="usage-type-chart"
          [isRefreshing]="isDnReportDataRefreshing()"
          [isError]="isDnReportWidgetError"
          [data]="usageTypeData"
          [label]="'tkey;migrations.number_report.dashboard.usage_type.label'"
          [labelTooltip]="'tkey;migrations.cisco.directory_numbers_report.dashboard.usage_type.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="usageTypeCustomColors"
          [segmentTooltipKeyword]="'tkey;migrations.cisco.directory_numbers_report.dashboard.lines.label'"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onDnReportFilter($event, 'lineType')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="device-type-chart"
          [isRefreshing]="isDnReportDataRefreshing()"
          [isError]="isDnReportWidgetError"
          [data]="deviceTypeData"
          [label]="'tkey;migrations.number_report.dashboard.device_type.label'"
          [labelTooltip]="'tkey;migrations.cisco.directory_numbers_report.dashboard.device_type.tooltip.label'"
          [colorScheme]="colorScheme"
          [customColors]="deviceTypeCustomColors"
          [segmentTooltipKeyword]="''"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label'"
          (dataClick)="onDnReportFilter($event, 'deviceType')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="suggested-calling-product-chart"
          [isRefreshing]="isDnReportDataRefreshing() && isCdrFileUploaded && cdrDiffDays > MIN_CDR_DAYS"
          [isError]="isDnReportWidgetError && isCdrFileUploaded"
          [data]="suggestedProductData"
          [label]="'tkey;migrations.cisco.directory_numbers_report.dashboard.suggested_calling_product.label'"
          [labelTooltip]="
            'tkey;migrations.cisco.directory_numbers_report.dashboard.suggested_calling_product.label.tooltip'
          "
          [colorScheme]="colorScheme"
          [isDisabled]="!cdrDiffDays || cdrDiffDays < MIN_CDR_DAYS"
          [disabledText]="suggestedProductsDisabledText"
          [segmentTooltipKeyword]="''"
          [totalSubtext]="'tkey;migrations.number_report.dashboard.total_numbers.label'"
          [legendCountLabelSingular]="'tkey;migrations.number_report.dashboard.numbers.label.singular'"
          [legendCountLabelPlural]="'tkey;migrations.number_report.dashboard.numbers.label.plural'"
          (dataClick)="onDnReportFilter($event, 'callingProduct')"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-text-card
          data-automation="hunt-list-card"
          [isRefreshing]="isHuntListRefreshing()"
          [isError]="isHuntListError"
          [data]="huntListData"
          [label]="'tkey;migrations.cisco.directory_numbers_report.dashboard.hunt_list.label'"
          [labelTooltip]="'tkey;migrations.cisco.directory_numbers_report.dashboard.hunt_list.label.tooltip'"
          (dataClick)="onHuntListClick()"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-text-card>
      </div>
      <div class="dashboard-widget">
        <ziro-migrations-donut-chart
          data-automation="auto-attendant-chart"
          [isRefreshing]="isAutoAttendantRefreshing()"
          [isError]="isAutoAttendantReportWidgetError"
          [data]="autoAttendantsData"
          [label]="'tkey;migrations.cisco.directory_numbers_report.dashboard.auto_attendant.label'"
          [labelTooltip]="'tkey;migrations.cisco.directory_numbers_report.dashboard.auto_attendant.label.tooltip'"
          [colorScheme]="colorScheme"
          [customColors]="autoAttendantCustomColors"
          [isDisabled]="!isUnityFileUploaded"
          [disabledText]="autoAttendantsDisabledText"
          [segmentTooltipKeyword]="''"
          [totalSubtext]="'tkey;migrations.cisco.directory_numbers_report.dashboard.auto_attendant.total.subtext'"
          [legendCountLabelSingular]="
            'tkey;migrations.cisco.directory_numbers_report.dashboard.auto_attendant.label.singular'
          "
          [legendCountLabelPlural]="
            'tkey;migrations.cisco.directory_numbers_report.dashboard.auto_attendant.label.plural'
          "
          (dataClick)="onAutoAttendantReportFilter($event)"
          (errorButtonClick)="onRefreshClick()"
        ></ziro-migrations-donut-chart>
      </div>
    </div>
  }
</div>
